export default "__VITE_ASSET__Badj70jo__"